import _classCallCheck from "/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import ApplicationResource from './ApplicationResource';

var AdminMediaResource = /*#__PURE__*/function (_ApplicationResource) {
  _inherits(AdminMediaResource, _ApplicationResource);

  var _super = _createSuper(AdminMediaResource);

  function AdminMediaResource() {
    var _this;

    _classCallCheck(this, AdminMediaResource);

    _this = _super.apply(this, arguments);
    _this.id = '';
    _this.name = '';
    _this.size = '';
    _this.type = {};
    return _this;
  }

  _createClass(AdminMediaResource, [{
    key: "pk",
    value: function pk() {
      return this.id;
    }
  }], [{
    key: "createShape",
    value: function createShape() {
      var options = AdminMediaResource.getEndpointExtra();
      return {
        type: 'mutate',
        schema: this,
        options: options,
        getFetchKey: function getFetchKey(params) {
          return 'POST ' + AdminMediaResource.listUrl(params);
        },
        fetch: function fetch(params, body) {
          return AdminMediaResource.fetch(AdminMediaResource.listUrl(params), {
            method: 'post',
            body: body
          });
        }
      };
    }
  }]);

  return AdminMediaResource;
}(ApplicationResource);

export { AdminMediaResource as default };
AdminMediaResource.resource = '/admin/media';